// extracted by mini-css-extract-plugin
export default {"ShortUrlsPage":"ShortUrlsPage_ShortUrlsPage__uupfD","ActionButton":"ShortUrlsPage_ActionButton__9OfmB"};